export default function () {
    const approot = document.body.getAttribute('data-approot');

    document.querySelectorAll('.resolveDNS').forEach(item => {
        fetch(`${approot}panel/methods/dnsName`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ data: item.textContent })
        }).then(response => {
            return response.json();
        }).then(data => {
           
            item.textContent = data.name;
        });
    });
}